import { isTestMode } from "dashboard-utils";

const TEST_ORCHESTRATION_LAYER = 'https://uatoneapi.payu.in';
const TEST_MARKETPLACE_HOST = 'https://uatoneapi.payu.in/neo-marketplace';
const TEST_MARKETPLACE_HOST_DI = 'https://uatoneapi.payu.in/marketplace-service';

export const appUrls = {
  ORCHESTRATION_LAYER: isTestMode ? TEST_ORCHESTRATION_LAYER : process.env.ORCHESTRATION_LAYER,
  MARKETPLACE_HOST: isTestMode ? TEST_MARKETPLACE_HOST : process.env.MARKETPLACE_HOST,
  MARKETPLACE_HOST_DI: isTestMode ? TEST_MARKETPLACE_HOST_DI : process.env.MARKETPLACE_HOST_DI,
  VISTA_DASHBOARD_HOST: process.env.VISTA_DASHBOARD_HOST,
  MEDIA_HOST: process.env.MEDIA_HOST,
  VISTA_APPLICATION: process.env.VISTA_APPLICATION,
  DASHBOARD_HOST: process.env.DASHBOARD_HOST,
  ONBOARDING_HOST: process.env.ONBOARDING_HOST,
};

export const endPoints = {
  DOWNTIME_LIST: '/downtime/notificationData',
  DOWNTIME_FILTER: '/downtime/filterData',
  MERCHANT_PARAMS: "/merchants/params",
  SETTINGS: {
    TOKEN_INFO: "/api/v3/oauth/token/info",
  },
  MERCHANT_DETAILS: merchant_account_uuid => `/v3/merchant-details/${merchant_account_uuid}`,
  FETCH_UAT_MID: merchant_account_uuid => `/api/v3/product_accounts/${merchant_account_uuid}/fetch_uat_mid_details`,
  CO_LOGIN_REDIRECT: "/account/service_login?redirect_to=",
  CO_LOGOUT_REDIRECT: "/account/service_logout?redirect_to=",
  MARKETPLACES_OLD: "/ecombooks/marketplaces",
  MARKETPLACES_NEW: "/merchant/dashboard/marketplaces",
  DASHBOARD_STATUS_API: "/merchant/dashboard/integration/status",
  MERCHANT_OFFER_STATUS : "/fetchContent",
  CREATE_OR_UPDATE_CONSENT: product_account_uuid => `/api/v3/product_accounts/${product_account_uuid}/consents/create_or_update`,
  GET_CONSENT: product_account_uuid => `/api/v3/product_accounts/${product_account_uuid}/consents/`,
};
